import { Component, OnChanges, Input, Output, EventEmitter, Directive } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { DialogTicketing } from '../../dialog/ticketing/dialog.component.ticketing';

import { TListService } from '../services/ticketing.service';
import { TicketingService } from '../../services/ticketing-service/ticketing.service';

import { ISPI } from '../ticketing.interfaces';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';

@Directive()
export class BaseTicketingListComponent {
  @Input('elementList') elementList: any;

  public activeFilters: any = {stateReunio: true, stateMailstone: false};
  public currentOrdering: any = {};
  public orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  public showFilters: boolean = true;
  public orderingParameters: any;

  private ticketingModel: ISPI = {
    'id': 'NEW',
    'projecte_codi': '',
    'tipus': '',
    'id_tipus': null,
    'sub_tipus': '',
    'personal_id': '',
    'assumpte': '',
    'data_peticio': '',
    'hora': '',
    'acords': '',
    'data_acord': '',
    'data_denegacio': '',
    'estat': '',
    'filename': '',
    'file': '',
    'data_realitzacio': '',
    'urgencia': 0,
  };
  private unsubscriber : Subject<void> = new Subject<void>();

  public showDialog: boolean = false;
  public showAsyncProgress: boolean = false;
  public ticketingData: Array<ISPI>;;
  public editTicketingData: ISPI;

  public editTicket(ticketing: ISPI): void {
   this.editTicketingData = ticketing;

   let dialogSegTecRef=this.dialog.open(DialogTicketing, {disableClose: true, width: '850px', height: '550px', data: this.editTicketingData })

   dialogSegTecRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editTicketingData = results;
      this.addOrUpdateUser();
    });
  }

  public addTicket(): void {
   this.editTicketingData = Object.assign(
     {},
     this.ticketingModel
   );

   let dialogSegTecRef=this.dialog.open(DialogTicketing, {disableClose: true, width: '850px', height: '550px', data: this.editTicketingData })
   
   dialogSegTecRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editTicketingData = results;
      this.addOrUpdateUser();
    });
  }

  public addOrUpdateUser(/*$event*/): void {
    this.showAsyncProgress = true;
    this.showDialog = false;
    if (this.editTicketingData.id === 'NEW') {
      this.manageTicketsService.create(this.editTicketingData)
        .subscribe(newSeguiment => {
          this.showAsyncProgress = false;
        },
          err => console.log(err)
        );
    } else {
      this.manageTicketsService.updateData(<number> this.editTicketingData.id, this.editTicketingData)
        .subscribe(updatedTicket => {
          this.ticketingData = this.ticketingData.map(ticket => {
            return (ticket.id === updatedTicket.id ? updatedTicket : ticket);
          },
          err => console.log(err)
        );
          this.showAsyncProgress = false;
        });
    }
  }

  public deleteSeguimentTecnic(ticketToDelete: ISPI): void {
    if(confirm("Confirma l'esborrat del seguiment programat")){
      this.showAsyncProgress = true;
      this.showDialog = false;
      this.manageTicketsService.deleteData(<number> ticketToDelete.id)
        .subscribe(deletedSeguiment => {
          this.ticketingData = this.ticketingData.filter(seguiments => seguiments.id !== deletedSeguiment.id);
          this.showAsyncProgress = false;
        },
         err => console.log(err)
        );
    }
  }

  public export(){
    var csvData = this.convertToCSV( this.ticketingData);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData.replace(/,/g,"").replace(/\./g,",")], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    var x:Date = new Date();
    var link:string ="ticketing_" + x.getMonth() +  "_" +  x.getDay() + '.csv';
    a.download = link.toLocaleLowerCase();
    a.click();
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listService.currentPage * this.listService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listService.rowsPerPage - 1, this.elementList.registers);
  }
  
  public pendentRealitzar(data1, data2, op){
    var currentDate = moment().format("YYYY-MM-DD");
    if(op == 0)if(data1 && !data2) return true;//Pendent de realitzar
    if(op == 1)if(data1 && data2) return true;//Realitzada
    if(op == 2)if(!data1 && !data2) return true;//Pendent d'acceptar o denegar
    if(op == 3)if(data2) return true;//Denegada
    return false;
  }
  
  private requestRowsToParent(): void {
    this.manageTicketsService.getActive(
      this.listService.rowsPerPage,
      (this.firstRegisterShown?this.firstRegisterShown:1) - 1,
      this.activeFilters,
      {},
      this.currentOrdering)
      .subscribe(
        elements => { this.elementList = elements;},
        error => console.log(error)
    );
  }

  public computeActiveFilters($event) {
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listService.currentPage * this.listService.rowsPerPage;
    this.requestRowsToParent();
  }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  public requestPrevious(): void {
    this.listService.currentPage = Math.max(0, this.listService.currentPage - 1);
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public requestNext(): void {
    this.listService.currentPage = Math.min(Math.floor(this.elementList.registers / this.listService.rowsPerPage), this.listService.currentPage + 1);
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public gotoPage(page: number): void {
    this.listService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public navigateToProject(project) {
    this.router.navigate([this.routeKey, project.codi]);
  }

  public setRowPerPage(rowsPerPage: number) {
    this.listService.rowsPerPage = rowsPerPage;
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
    this.showFilters = !this.showFilters;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, public listService: TListService, public manageTicketsService: TicketingService, private router: Router, public dialog: MatDialog, public tableFields, private routeKey: string,
              public validFilters: Array<any>,public ordreCamps: Array<any>) {
    this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    for(var i=0;i<ordreCamps.length;i++){this.orderingParameters[ordreCamps[i].key] = ordreCamps[i].sort;this.cycleOrdering(ordreCamps[i].key);}
//    this.computeActiveFilters({pendentsReal: true});  
  }

  ngOnChanges(changes: any): void {
    const newElementList = changes.elementList.currentValue;
    if(newElementList){this.requestRowsToParent();this.computeDisplayedRows();}
  }

}

@Component({
  selector: 'mcrit-gestio-ticketing-list',
  templateUrl: 'ticketing-list.component.html',
  styleUrls: ['ticketing-list.component.css'],
  providers: []
})
export class TicketingListComponent extends BaseTicketingListComponent {
  @Input('elementList') elementList: any;
  @Output('requestRows') requestRows = new EventEmitter();

  public title: string = 'Ticketing';
  public ticketingData: Array<ISPI>;
  public isDate(field: string): boolean { return (field === 'data'); }

  ngOnInit(){ }

  constructor(public translate: TranslateService, public languageService: LanguageService, listService: TListService, manageTicketsService: TicketingService, router: Router, dialog: MatDialog ) {
    super(translate, languageService, listService, manageTicketsService, router, dialog, [
      ['data', 'Data petició'],
      ['tipus', 'Tipus'],
      ['sub_tipus', 'Sub tipus'],
      ['personal_id', 'Usuari'],
      ['data_acord', 'Aprovat'],
      ['data_realitzacio', 'Realitzat'],
    ], 'project', [
      {
        inputs: [
          {
            name: 'checkbox',
            type: 'checkbox',
            values: [
             {
              text: 'Pendents realitzar',
              name: 'pendentsReal',
              value: true
             },
             {
              text: 'Realitzats',
              name: 'estatRealitzat',
              value: false
             },
             {
              text: 'Pendents acceptar',
              name: 'pendentsAcord',
              value: false
             },
             {
              text: 'Denegats',
              name: 'pendentsDenegacio',
              value: false
             }
            ]
          }
        ]
      },
      {
        inputs: [
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: 'Data petició',
                name: 'data_peticio',
                value: '',//new Date().getFullYear().toString()+"/"+("0" + new Date().getMonth()+1).slice(-2).toString()+'/'+("0"+new Date().getDate()).slice(-2).toString()
              },
              {
                text: 'Tipus',
                name: 'tipus',
                autocomplete: 'tipusTicket',
                value: listService.getSearchValues('tipus')
              },
              {
                text: 'Sub tipus',
                name: 'sub_tipus',
                autocomplete: 'subTipusTicket',
                value: listService.getSearchValues('sub_tipus')
              },
              {
                text: 'Usuari',
                name: 'personal_id',
                autocomplete: 'tecnicMcrit',
                value: listService.getSearchValues('personal_id')
              }
            ]
          }
        ]
      }
    ],[{key:'data_peticio',sort: 1}]);
  };
}
